<template>
    <div class="participant-status" :class="{'participant-status-border': bottom == true}">
      <!-- <div v-if="isCurrentUser" :class="currentUserCustomClass">
        {{ $t(notificationMessage) }}
      </div> -->
      <template v-if="!displaySuccessMessage">
        <div class="button-actions d-flex justify-content-center mb-4" :class="{'button-actions-margin': bottom == true}" v-if="isChoicesInViewMode && isAnswerEditable(participant)">
          <Btn
            v-if="isResponseEditable(participant)"
            @click.native="onEdit()"
            :label="$t('options.editResponseMobile')"
            :loading="loading"
          />
        </div>

        <div class="nav-float bottom-navigation" v-show="!isChoicesInViewMode">
          <div class="d-flex align-items-center justify-content-center h-100">
              <BtnLink
                @click.native="onCancel"
                class="mx-1"
                :label="$t('options.cancelResponse')"
              />
              <Btn
                @click.native="onSubmit"
                :label="$t('options.submitResponseMobile')"
                :loading="loading"
              />
          </div>
        </div>

        <!-- <div
          :class="cssTheme"
          class="response-message mt-1"
          v-if="0 && submittingParticipant"
        >
          {{ $t('submit.responseMessage') }} <br />
          [
          <span>
            <font-awesome-icon :icon="['fas', 'check']" class="k-checked" />
            {{ $t('general.yes') }}, &nbsp;
          </span>
          <span class="k-checked">
            (<font-awesome-icon :icon="['fas', 'check']" />)
          </span>
          <span> {{ $t('general.maybe') }}, &nbsp;</span>
          <span>
            <font-awesome-icon class="k-checked" :icon="['fas', 'times']" />
            {{ $t('general.no') }}
          </span>
          ]
        </div> -->

      </template>
      <div class="response-success" v-else>
        <span> {{ $t('options.partialAnswerSubmitted2') }} </span>
      </div>
    </div>
</template>

<script>
import { renderMixin } from '../mixins/RenderMixins';
import { themeMixin } from '../mixins/ThemeMixins';

export default {
  name: 'RenderMobileChoiceActionItem',
  props: ['displaySuccessMessage', 'participant', 'isChoicesInViewMode', 'loading', 'bottom'],
  mixins: [renderMixin, themeMixin],
  methods: {
    onEdit() {
      this.$emit('onEdit', this.participant);
    },
    onSubmit(){
        this.$emit('onSubmit');
    },
    onCancel() {
        this.$emit('onCancel');
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/styles/style.scss';

.participant-status {
  margin: 2px;
  margin-left: 14px;
  margin-right: 14px;
  text-align: center;
}
.response-success {
  background-color: $primary-dark;
  color: $white;
}
.edit-response-details {
  text-align: center;
  .response-heading {
    font-weight: 600;
  }
}
.response-message {
  font-size: $very-small;
}

.fa-stack-1x {
  line-height: inherit;
}

.fa-stack-2x {
}

.fa-stack-1x,
.fa-stack-2x {
  position: absolute;
  left: 0;
  width: 100%;
  text-align: center;
}

.participant-status-border {
    border-top: 1px solid;
}

.button-actions {
  button {
    width: 100%;
  }
}

.button-actions-margin {
    margin-top: 15px;
}

.nav-float {
  background-color: $very-light-grey;
  box-shadow: 0px 5px 18px 9px $mid-grey;
  z-index: 9;
}
</style>
